import React, { useState, useEffect, useRef } from "react";
import DocumentViewer from "./DocumentViewer";
import "semantic-ui-css/semantic.min.css";
import "../../index.css";
import { Message, Icon, Checkbox, Loader, Dropdown } from "semantic-ui-react";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import { axiosInstance } from "../../fetcher";
import { APP_SETTINGS } from "../../env";

//Style for the components
const style = {
  button: {
    backgroundColor: "#0D6EFD",
    color: "#fff",
    marginRight: "20px",
    border: "#281671",
    marginLeft: "20px",
  },
  file: {
    width: "200%",
    height: "80%",
    color: "#808080",
    padding: "50px",
    border: "1px solid #D3D3D3",
  },
  dropDownL: {
    padding: "8px",
    fontSize: "14px",
    borderRadius: "5px",
    border: "1px solid #ccc",
    backgroundColor: "#fff",
  },
  customToastStyle: {
    background: "#28a745",
    color: "#FFFFFF", // Text color on the toast
    margin: "0 auto",
    width: "300px",
  },

  typeFile: {
    marginTop: "40px",
    height: "0px",
    width: "0px",
    textWrap: "unset",
    visibility: "hidden",
  },
  img1: {
    height: "3rem",
    margin: "0.5rem",
  },
  fileback: {
    border: "1px solid #D3D3D3",
    color: "rgb(154,160,166)",
    "border-radius": "8px",
    "max-width": "640px",
    padding: "18px 0",
    background:
      "linear-gradient(to right,rgb(232,240,254) 50%,rgb(241,243,244) 50%)",
    "background-position": "right bottom",
    "background-size": "200% 100%",
    margin: "auto",
  },
};
// For checking purpose
console.log("Bootstrap object:", window.bootstrap);

const DocumentTranslator = (props) => {
  const [pdfFile, setPdfFile] = useState(null);

  const [pdfloading, setPDFLoading] = useState(false);
  const [fileData, setFileData] = useState(null);
  const [uploadedfilename, setuploadedfilename] = useState(null);
  const [fileDataExtension, setFileDataExtension] = useState(null);
  const [translatedData, setTranslatedData] = useState(null);

  const [targetLanguage, setTargetLanguage] = useState("en");
  const [sourceLanguage, setSourceLanguage] = useState("default");
  const [sourceLanguageOptions, setSourceLanguageOptions] = useState([]);
  const [includeGlossary, setIncludeGlossary] = useState(false);
  const [loaderStatus, setLoaderStatus] = useState(false);
  const [glossaryState, setGlossaryState] = useState(false);
  const [glossaryMessageVisible, setGlossaryMessageVisible] = useState(false);

  const [languageList, setLanguageList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadingDoc, setLoadingDoc] = useState(false);
  const [isTranslateWithGlossary, setIsTranslateWithGlossary] = useState(false);
  const refinputfile = useRef(null);
  const [hideFileUploadSection, setHideFileUploadSection] = useState(true);
  const [checkBoxStatus, setCheckBoxStatus] = useState(false);
  const [glossaryLanguage, setGlossaryLanguage] = useState("default");
  const [targetLanguageOptions, setTargetLanguageOptions] = useState([]);

  const [engagementName, setEngagementName] = useState("");
  const [apiIdName, setApiIdName] = useState("");
  
  const currentDomain = window.location.hostname.split(".")[1];

  let endpointToUse;

  if (currentDomain === "azurewebsites") {
    endpointToUse = new URL(APP_SETTINGS.public_endpoint).origin;
  } else {
    endpointToUse = new URL(APP_SETTINGS.private_endpoint).origin;
  }
  const currentUrl = endpointToUse;

  useEffect(() => {
    fetchSupportedLanguages();

    checkparam();
  }, []);

  const checkparam = async () => {
    try {
      const responseEngagementName = await axiosInstance.post(
        "/engagements/get_engagements_name", { url: currentUrl }
      );

      // const responseApiId = await axiosInstance.get("/get_api_id_docs");

      setEngagementName(responseEngagementName.data.engagement_name);
      // setApiIdName(responseApiId.data);
      // setApiIdName(responseApiId.data.doc_translate); 
      // console.log(
      //   "OS Param value is - ",
      //   responseApiId.data,
      //   responseEngagementName.data
      // );
    } catch (error) {
      console.error("Error fetching engagment ID and API ID:", error);
    }
  };

  const fetchSupportedLanguages = async () => {
    try {
      const response = await axiosInstance.get(
        "/glossary/get_supported_languages"
      );
      if (response.data.data.languages) {
        const defaultOption = [
          { key: "default", value: "default", text: "Auto-Detect" },
        ];

        const languageOptions = [
          ...response.data.data.languages
            .filter((ele) => ele.languageCode !== "auto")
            .sort((a, b) => a.languageName.localeCompare(b.languageName))
            .map((ele) => {
              return {
                key: ele.languageCode,
                value: ele.languageCode,
                text: ele.languageName,
              };
            }),
        ];

        const sourceLanguageOptions = defaultOption.concat(languageOptions);

        // console.log("options", languageOptions);
        setSourceLanguageOptions(sourceLanguageOptions);
        setTargetLanguageOptions(sourceLanguageOptions);
        setLanguageList(response.data.languages);
        setIncludeGlossary(false);
        setCheckBoxStatus(true);
        setSourceLanguage("default");
        setTargetLanguage("en");
      }
    } catch (error) {
      console.error("Error fetching supported languages:", error);
    }
  };

  const handleDropFile = (event) => {
    event.preventDefault();

    const selectedFile = event.dataTransfer.files[0];

    if (selectedFile) {
      const fileExtension = selectedFile.name.split(".").pop().toLowerCase();
      const fileSize = selectedFile.size / (1024 * 1024);
      if (fileSize > 200) {
        alert("File size exceeds 200MB limit");
      } else if (!selectedFile.name.match(/\.(pdf|docx|xlsx|pptx)$/i)) {
        alert(
          "Invalid file type. Please upload a PDF, Word, Excel or PPT file"
        );
      } else {
        getPdfDataToDisplay(selectedFile);
        setuploadedfilename(selectedFile.name);
        captureFileData(selectedFile);
        setFileDataExtension(fileExtension);
        setPDFLoading(true);
        setTranslatedData(null);

        // Show the toast notification
        // const toast = document.getElementById("customToast");
        // const bsToast = new window.bootstrap.Toast(toast);
        // bsToast.show();
        // Hide the toast after a certain period of time (optional)
        // setTimeout(() => bsToast.hide(), 2500); // Hide after 3 seconds
        const toast = document.getElementById("customToast");

        if (toast && window.bootstrap?.Toast) {
          const bsToast = new window.bootstrap.Toast(toast);
          bsToast.show();

          setTimeout(() => {
            if (bsToast?.hide) {
              bsToast.hide();
            } else {
              console.warn("Toast instance or hide method is not available.");
            }
          }, 2500);
        } else {
          console.warn("Toast element or Bootstrap Toast is not available.");
        }


        
        setHideFileUploadSection(false);
        setGlossaryLanguage("default");
      }
    } else {
      // Show a message indicating nothing was selected
      alert("Please select a file!");
    }
  };
  //To handles the change event when a user selects a PDF or Word file for processing.
  const handlePdfFileChange = (event) => {
    event.preventDefault();
    const selectedFile = event.target.files[0];

    if (selectedFile) {
      const fileExtension = selectedFile.name.split(".").pop().toLowerCase();
      const fileSize = selectedFile.size / (1024 * 1024);
      if (fileSize > 40) {
        alert("File size exceeds 40MB limit");
      } else if (!selectedFile.name.match(/\.(pdf|docx|xlsx|pptx)$/i)) {
        alert(
          "Invalid file type. Please upload a PDF , Word, Excel or PPT file"
        );
      } else {
        getPdfDataToDisplay(selectedFile);
        setuploadedfilename(selectedFile.name);

        // refinputfile.current.value = selectedFile.name;
        captureFileData(selectedFile);
        setFileDataExtension(fileExtension);
        setPDFLoading(true);
        setTranslatedData(null);

        // Show the toast notification
        //const toast = document.getElementById("customToast");
        //const bsToast = new window.bootstrap.Toast(toast);
        // bsToast.show();

        // // Hide the toast after a certain period of time (optional)
        // setTimeout(() => bsToast.hide(), 2500); // Hide after 3 seconds
        setHideFileUploadSection(false);
        setIsTranslateWithGlossary(false);
      }
    } else {
      // Show a message indicating nothing was selected
      alert("Please select a file!");
    }
  };

  //T0 read the selected PDF file
  const getPdfDataToDisplay = (selectedFile) => {
    let reader = new FileReader();
    reader.onloadend = (e) => setPdfFile(e.target.result);
    reader.readAsDataURL(selectedFile);
  };

  //Appending the file data for sending to a server for further processing
  const captureFileData = (selectedFile) => {
    const data = new FormData();
    const originalFilename = selectedFile.name;
    const filename = originalFilename
      .replace(/\s+/g, "_")
      .replace(/[()]/g, "")
      .replace(/[^\w\d.]/g, "");
    data.append("file", selectedFile);

    data.append("filename", filename);

    setFileData(data);
  };

  const downloadFile = async () => {
    try {
      console.log(fileData)
      const response_data = await axiosInstance.post(`/downfiles/download_file_doc`, fileData)
      console.log("response_data.data :", response_data.data)
      console.log("response_data.data.data : ", response_data.data.data)
      console.log("response_data.data.data.data :", response_data.data.data.data)
      

      // window.location.href = download_file.data;
      await axios({
        url: response_data.data.data.data,
        method: "GET",
        responseType: "blob",
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", uploadedfilename);
        document.body.appendChild(link);
        link.click();
      });
    } catch (error) {
      console.error("Error fetching Downlaoded files:", error);
    }
  };

  const translateDocument = async () => {
    try {
      setTranslatedData(null);
      setGlossaryMessageVisible(false);
      if (fileDataExtension === "pdf") {
        setLoading(true);
      }
      setLoadingDoc(true);
  
      // Create FormData for file upload
      const formData = new FormData();
      const file = fileData.get('file');
      formData.append('file', file);
      formData.append('filename', uploadedfilename);
      console.log(file,"file")
      console.log(fileData,"filDatae")

  
      // Upload file
      await axiosInstance.post("/upload/upload", formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
  
      // Upload to blob
      await axiosInstance.post("/upload/upload_blob", formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
      
      const currentDomain = window.location.hostname.split(".")[1];
      
      let endpointToUse;
      
      if (currentDomain === "azurewebsites") {
        endpointToUse = new URL(APP_SETTINGS.public_endpoint).origin;
      } else {
        endpointToUse = new URL(APP_SETTINGS.private_endpoint).origin;
      }
      // Continue with document translation
      await axiosInstance.post(`/translation/translateDocument`, {
        apiID: apiIdName,
        engagementName: engagementName,
        fileName: uploadedfilename,
        hostnameURL: endpointToUse,
        includeGlossary: includeGlossary,
        sourceLanguage: sourceLanguage,
        targetLanguage: targetLanguage,
      });

      const download_file = (
        await axiosInstance.post(`/downfiles/download_file`, fileData)
      ).data;
  
      if (download_file) {
        setTranslatedData(download_file.data.data);
        setLoading(true);
      }
       
      setGlossaryState(includeGlossary);
      setGlossaryMessageVisible(true);
    } catch (e) {
      console.error("Error during translation:", e);
      // You might want to add error handling here
    }

    setLoading(false);
    setLoadingDoc(false);
    await axiosInstance.post(`/downfiles/delete_files`, fileData);
    setIncludeGlossary(false);
  };


  const getGlossaryAvailability = async (
    sourceLanguageValue,
    targetLanguageValue
  ) => {
    // console.log("hit");
    try {
      if (
        targetLanguageValue !== "default" &&
        sourceLanguageValue !== "default"
      ) {
        const glossaryAvailabilityResponse = await axiosInstance.post(
          `/glossary/Glossary_availability`,
          {
            target_language_code: targetLanguageValue,
            source_language_code: sourceLanguageValue,
            engagementName: engagementName, // "EN01"
          }
        );
        // console.log("Glossary Status", glossaryAvailabilityResponse.data);
        if (glossaryAvailabilityResponse.data.data == "True") {
          setCheckBoxStatus(false);
        } else {
          setCheckBoxStatus(true);
        }
      } else if (sourceLanguageValue === "default") {
        setCheckBoxStatus(true);
        setIncludeGlossary(false);
      }
    } catch (e) {
      console.log(e);
    }
  };

  const triggerFileInput = async (e) => {
    refinputfile.current.click();
  };

  const handleClear = async (event) => {
    setHideFileUploadSection(true);
    event.preventDefault();
    setuploadedfilename(null);
    setPdfFile(null);
    setPDFLoading(false);
    setLoading(false);
    setLoadingDoc(false);
    setTranslatedData(null);
    setGlossaryMessageVisible(false);
    setIncludeGlossary(false);
  };
  return (
    <>
      <div className="row">
        {/* Dropdown starts */}

        <div className="row mt-1">
          <div className="col">
            <div className="row ">
              {/* Dropdown Selector 1 - Select Source Lang - Start */}

              <div className="col">
                <label htmlFor="sourceLanguage" style={{ marginRight: "10px" }}>
                  <b>Select Source Language</b>
                </label>
                <Dropdown
                  search
                  fluid
                  floating
                  selection
                  options={sourceLanguageOptions}
                  value={sourceLanguage}
                  onChange={(e, data) => {
                    setSourceLanguage(data.value);
                    setIncludeGlossary(false);
                    getGlossaryAvailability(data.value, targetLanguage);
                  }}
                />
              </div>
              <div className="col">
                <label htmlFor="targetLanguage" style={{ marginRight: "10px" }}>
                  <b>Select Target Language</b>
                </label>
                <Dropdown
                  search
                  fluid
                  floating
                  selection
                  options={targetLanguageOptions}
                  value={targetLanguage}
                  onChange={(e, data) => {
                    setTargetLanguage(data.value);
                    setIncludeGlossary(false);
                    getGlossaryAvailability(sourceLanguage, data.value);
                  }}
                />
              </div>
            </div>
          </div>
        </div>
        <div
          className="row"
          id="outerdiv"
          style={{ marginTop: "10px" }}
          onDragOver={(event) => {
            event.preventDefault();
          }}
          onDrop={(event) => handleDropFile(event)}
        >
          {hideFileUploadSection && (
            <div className="text-center" style={style.file}>
              <div>
                {/* Hello */}
                <img style={style.img1} src="pdf.png" alt="Pdf file" />
                <img style={style.img1} src="word.png" alt="Word file" />
                <img style={style.img1} src="excel.png" alt="Excel file" />
                <img style={style.img1} src="ppt.png" alt="PPT file" />
              </div>
              <div>
                Drag and Drop a file here or click on upload. File upload limit
                is upto 40MB for each file (.pdf,.docx,.xlsx,.pptx)
              </div>
              <input
                type="file"
                id="inptranslationfile"
                name="inptranslationfile"
                //accept="application/pdf"
                accept=".doc,.docx,.pdf,.xlsx,.pptx"
                // className="form-control"
                className="custom-file-input"
                style={style.typeFile}
                ref={refinputfile}
                onChange={(event) => handlePdfFileChange(event)}
              />
              <button
                className="btn btn-primary"
                style={{ margin: "3ch" }}
                onClick={triggerFileInput}
              >
                Browse your file
              </button>

              <div
                id="customToast"
                className="toast"
                role="alert"
                aria-live="assertive"
                aria-atomic="true"
                style={style.customToastStyle}
              >
                <div className="toast-body">File uploaded successfully!</div>
              </div>
            </div>
          )}
          {!hideFileUploadSection && (
            <div id="dvfilename" className="text-center" style={style.file}>
              <div style={style.fileback}>
                <i aria-hidden="true" class="file icon"></i>
                <label
                  style={{
                    color: "#0D6EFD",
                    marginLeft: "8px",
                    marginRight: "50px",
                  }}
                >
                  <b>{uploadedfilename}</b>
                </label>
                <i
                  aria-hidden="true"
                  class="delete icon"
                  onClick={handleClear}
                ></i>
              </div>
            </div>
          )}
        </div>
        <div>
          <div className="row mt--1">
            {glossaryMessageVisible ? (
              <div style={{ display: "flex", justifyContent: "flex-end" }}>
                <div
                  style={{
                    textAlign: "left",
                    display: "flex",
                    alignItems: "center",
                    color: "green",
                  }}
                >
                  <p style={{ color: "red", margin: 0 }}>*</p>
                  <div style={{ marginLeft: "5px" }}>
                    {glossaryState ? (
                      <div style={{ display: "grid-row" }}>
                        Document translation is completed with glossary.
                      </div>
                    ) : (
                      <div style={{ display: "grid-row" }}>
                        Document translation is completed without glossary.
                      </div>
                    )}
                  </div>
                </div>
              </div>
            ) : (
              <div></div>
            )}
          </div>
          <div className="row" style={{ marginTop: "-25px" }}>
            <div className="col">
              <Checkbox
                checked={includeGlossary}
                disabled={checkBoxStatus}
                onChange={(e, data) => setIncludeGlossary(data.checked)}
                label={<label>Include Glossary</label>}
              />
              <button
                id="translatedocbtn"
                type="button"
                className="btn btn-primary"
                style={style.button}
                onClick={translateDocument}
              >
                Translate
              </button>
              {/* <Loader inline active={loaderStatus} /> */}
            </div>

            <div className="col mt-1">
              {loadingDoc && (
                <div class="ui icon message" style={{ color: "green" }}>
                  <i aria-hidden="true" class="circle notched loading icon"></i>
                  <div class="content">
                    <div class="header">Translation under progress</div>We are
                    fetching the translated file for you.
                  </div>
                </div>
              )}
              {translatedData &&
                (fileDataExtension === "docx" ||
                  fileDataExtension === "pdf" ||
                  fileDataExtension === "pptx" ||
                  fileDataExtension === "xlsx") && (
                  <div>
                    {" "}
                    <button
                      id="translatedocdownlaodbtn"
                      className="btn btn-primary"
                      onClick={downloadFile}
                      target="_self"
                    >
                      Download translated file
                    </button>{" "}
                  </div>
                )}
            </div>
          </div>
        </div>
        <div className="row mt-2">
          <div className="col">
            {pdfloading && fileDataExtension === "pdf" && (
              <div>Original File</div>
            )}
            {pdfloading && fileDataExtension === "pdf" && (
              <DocumentViewer pdfFile={pdfFile} />
            )}
          </div>
          <div className="col relative-position">
            {translatedData && fileDataExtension === "pdf" && (
              <div>Translated File</div>
            )}
            {translatedData && fileDataExtension === "pdf" && (
              <DocumentViewer pdfFile={translatedData} />
            )}
            {loading && (
              <div className="ui active dimmer dimmer-overlay">
                <div className="ui loader"></div>
                <div className="loading-text">Loading ...</div>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default DocumentTranslator;
